<template>
  <el-form-item :label="label" :error="error">
    <el-switch
      v-model="withLimit"
      active-text="With limit"
      inactive-text="Unlimited"
    />
    <div v-show="withLimit">
      <el-input-number
        v-model="model.value"
        :min="0.1"
        :step="0.1"
        controls-position="left"
        @update:modelValue="update"
      />
    </div>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue'
import {
  CampaignBudgetLimitType,
  CampaignValidationErrorsKey
} from '@/api/types'
import useValidation from '@/hooks/useValidation'

const LABELS: { [key in CampaignBudgetLimitType]: string } = {
  budget_total: 'Total budget ($)',
  budget_hourly: 'Budget per hour ($)',
  budget_daily: 'Budget per day ($)'
}

export default defineComponent({
  name: 'BudgetLimits',
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    validationKey: {
      required: true,
      type: Symbol
    }
  },
  setup(props, context) {
    const model = ref(props.modelValue)
    const withLimit = ref(props.modelValue.value !== undefined)

    watch(withLimit, (newValue, _oldValue) => {
      if (newValue === false) {
        context.emit('remove', props.modelValue.type_id)
      }
    })

    const label = computed(() => {
      return LABELS[props.modelValue.type_id as CampaignBudgetLimitType]
    })

    const update = (newValue: number) => {
      context.emit('update:modelValue', {
        type_id: props.modelValue.type_id,
        value: newValue
      })
    }
    const { validationErrors } = useValidation(props.validationKey)

    const errors: any = validationErrors()

    const error = computed(() => {
      return errors.value ? errors.value[props.modelValue.type_id] : ''
    })

    return { label, update, withLimit, error, model }
  }
})
</script>
<style scoped lang="scss">
:deep(.el-switch) {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
</style>
